import moment from 'moment-timezone';
export const getSystemTimezone = () => moment.tz.guess();
